<template>
  <div>
  <div
    class="payment-schedule-table hidden lg:block xl:block"
  >
    <table class="table-auto w-full">
      <thead>
      <tr>
        <th class="px-4 py-2">
          Biển số xe
        </th>
        <th class="px-4 py-2">
          Lần gia hạn
        </th>
        <th class="px-4 py-2">
          Ngày hiệu lực đăng ký xe
        </th>
        <th class="px-4 py-2">
          Ngày hết hạn đăng ký xe
        </th>
        <th class="px-4 py-2">
          Ngày TFSVN gửi khách hàng
        </th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(item, index) in carRegistrationStatuses" :key="index">
        <td
          class="border px-4 py-2 text-center"
        >
          {{item.LincensePlate}}
        </td>
        <td
          class="border px-4 py-2"
        >
          {{item.NumOfRenewals}}
        </td>
        <td
          class="border px-4 py-2"
          v-if="item.StartDate && item.StartDate !== null"
        >
          {{item.StartDate | dateParse('YYYY-MM-DD') | dateFormat('DD/MM/YYYY')}}
        </td>
        <td
          class="border px-4 py-2"
          v-else
        >
        </td>
        <td
          class="border px-4 py-2"
          v-if="item.EndDate && item.EndDate !== null"
        >
          {{item.EndDate | dateParse('YYYY-MM-DD') | dateFormat('DD/MM/YYYY')}}
        </td>
        <td
          class="border px-4 py-2"
          v-else
        >
        </td>
        <td
          class="border px-4 py-2"
          v-if="item.TFSVNDate && item.TFSVNDate !== null"
        >
          {{item.TFSVNDate | dateParse('YYYY-MM-DD') | dateFormat('DD/MM/YYYY')}}
        </td>
        <td
          class="border px-4 py-2"
          v-else
        >
        </td>
      </tr>
      </tbody>
    </table>
  </div>
  <div
    class="payment-schedule-mobile block lg:hidden"
  >
    <div class="mobile-schedule-header">
      <p>Biển số xe</p>
      <p>Lần gia hạn</p>
    </div>
    <div
      class="mobile-schedule-content"
    >
      <div class="shadow-md">
        <div
          class="tab w-full overflow-hidden border-t"
          v-for="(item, index) in carRegistrationStatuses" :key="index"
        >
          <input
            class="absolute opacity-0 "
            :id="'tab-multi-' + index"
            type="checkbox"
            name="tabs"
          />
          <label class="block p-4 cursor-pointer flex justify-between" :for="'tab-multi-'+ index">
                <span class="flex items-center">
                    <img
                      class="mr-3 block"
                      src="@/assets/img/icon_plus.svg"
                      alt=""
                    />
                    <img
                      class="mr-3 hidden"
                      src="@/assets/img/icon_plus_2.svg"
                      alt=""
                    />
                    <p>{{item.LincensePlate}}</p>
                </span>
            <span>
              {{item.NumOfRenewals}}
            </span>
          </label>
          <div
            class="tab-content overflow-hidden"
          >
            <div
              class="flex flex-row p-4 pt-0"
            >
              <div
                class="w-1/2"
              >
                <p>Ngày hiệu lực đăng ký xe</p>
                <p>Ngày hết hạn đăng ký xe</p>
                <p>Ngày TFSVN gửi khách hàng</p>
              </div>
              <div
                class="w-1/2"
              >
                <p v-if="item.StartDate && item.StartDate !== null">
                  {{ item.StartDate | dateParse('YYYY-MM-DD') | dateFormat('DD/MM/YYYY')}}
                </p>
                <p v-else></p>
                <p v-if="item.EndDate && item.EndDate !== null">
                  {{ item.EndDate | dateParse('YYYY-MM-DD') | dateFormat('DD/MM/YYYY')}}
                </p>
                <p v-else></p>
                <p v-if="item.TFSVNDate && item.TFSVNDate !== null">
                  {{ item.TFSVNDate | dateParse('YYYY-MM-DD') | dateFormat('DD/MM/YYYY')}}
                </p>
                <p v-else></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
    <paginate
      v-model="pagination.page"
      :pageCount="pageCount"
      :containerClass="'pagination'"
      :prev-text="'<i class=&quot;iconvl icon-angle-left&quot;></i>'"
      :next-text="'<i class=&quot;iconvl icon-angle-right&quot;></i>'"
      :clickHandler="paginateCallback">
    </paginate>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

import prepareQueryParamsMixin from '@/mixins/prepareQueryParamsMixin'
import prepareFetchParamsMixin from '@/mixins/prepareFetchParamsMixin'

// import DataBox from '@/components/DataBox'
import Paginate from 'vuejs-paginate'

export default {
  name: 'PaymentHistory',
  mixins: [prepareQueryParamsMixin, prepareFetchParamsMixin],
  components: {
    // DataBox,
    Paginate
  },
  props: {
    contractNo: { type: String }
  },
  data () {
    return {
    }
  },

  methods: {
    fetchData () {
      this.$store.dispatch('carRegistrationStatuses/getListById', { id: this.contractNo, params: this.fetchParams })
    },
    paginateCallback: function (page) {
      this.$store.commit('carRegistrationStatuses/SET_PAGINATION', { page: page })
      this.fetchData()
    }
  },

  computed: {
    ...mapState('carRegistrationStatuses', {
      carRegistrationStatuses: 'items',
      pagination: 'pagination',
      error: 'error',
      loading: 'loading'
    }),
    ...mapGetters('carRegistrationStatuses', [
      'isEmpty'
    ]),
    fetchParams () {
      const pagination = this.prepareFetchParamsMixin({
        pageIndex: this.pagination.page
      })

      return { ...pagination }
    },
    pageCount () {
      return Math.ceil(this.pagination.total / this.pagination.limit)
    }
  },

  created () {
    this.fetchData()
  }
}
</script>
